import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		fieldContainer: {
			maxWidth: 576,
			width: "100%",
			[theme.breakpoints.down("sm")]: {
				maxWidth: "100%",
			},
		},
		// Refresh: static label above the field (14px/20px grey, 8px gap) — Figma Fields/Title.
		labelAbove: {
			display: "block",
			marginBottom: 8,
			fontSize: 14,
			lineHeight: "20px",
			color: theme.palette.custom.textSecondary,
		},
	} satisfies Record<string, CSSObject>)
}
